var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex--directionColumn" }, [
      _c(
        "ul",
        { staticClass: "flex flex--spacing20" },
        _vm._l(_vm.pagedItems, function (news, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass:
                "flex flex__item flex-s--justifyContent-center width33",
            },
            [
              _c("a", { attrs: { href: `/news/${news.uri}/${news.locale}` } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "margin-top-20 newsCard panelBox panelBox--hover panelBox--noPadding bg-white border-radius",
                  },
                  [
                    _vm.isDev
                      ? _c("img", {
                          attrs: {
                            src: news.headerPicture
                              ? _vm.getCdnLink(
                                  `NewsFeedCMSDev/${news.headerPicture}`,
                                  "cms"
                                )
                              : _vm.getCdnLink("img/news/news-archive.png"),
                            alt: news.headline,
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: news.headerPicture
                              ? _vm.getCdnLink(
                                  `NewsFeedCMS/${news.headerPicture}`,
                                  "cms"
                                )
                              : _vm.getCdnLink("img/news/news-archive.png"),
                            alt: news.headline,
                          },
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "padding-all-20" }, [
                      _c(
                        "div",
                        {
                          staticClass: "text-color--gray-blue margin-bottom-20",
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.getLocalizedDate(news.tstampPublished)
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "newsCard__title" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(news.headline) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "newsPagination" }, [
      _c(
        "button",
        {
          staticClass: "newsPagination__button",
          attrs: {
            type: "button",
            rel: "prev",
            "aria-label": _vm.trans("PREVIOUS_PAGE"),
            disabled: _vm.currentPage === 1,
          },
          on: { click: _vm.previousPage },
        },
        [
          _c("i", {
            staticClass: "fa fa-angle-left",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "newsPagination__currentPage" }, [
        _vm._v("\n            " + _vm._s(_vm.currentPage) + "\n        "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "newsPagination__separator" }, [
        _vm._v("\n            ⁄\n        "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "newsPagination__page" }, [
        _vm._v("\n            " + _vm._s(_vm.totalPages) + "\n        "),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "newsPagination__button",
          attrs: {
            type: "button",
            rel: "next",
            "aria-label": _vm.trans("NEXT_PAGE"),
            disabled: _vm.currentPage === _vm.totalPages,
          },
          on: { click: _vm.nextPage },
        },
        [
          _c("i", {
            staticClass: "fa fa-angle-right",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }